import React from 'react';
import { motion } from 'framer-motion';

const BookSummary = () => {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-center">

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-brand-600 font-semibold tracking-widest uppercase text-sm mb-4 block">
              What This Book Is About
            </span>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-900 mb-6 leading-tight">
              Love Is Often Quiet.<br />
              <span className="italic text-brand-600">That Doesn't Make It Less Real.</span>
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed mb-6">
              Society teaches us that romance must be loud — grand gestures, expensive gifts, and poetic declarations. But the most meaningful love is often invisible: showing up every day, easing burdens, solving problems, and creating emotional safety.
            </p>
            <p className="text-lg text-stone-600 leading-relaxed">
              <em>The Silent Language of Love</em> reframes ordinary acts — fixing things, remembering details, staying calm during hard times — as deeply loving behaviors, and invites you to see the profound romance already present in your relationship.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="space-y-6"
          >
            {[
              {
                label: "The Core Message",
                text: "Many men show love through action, not performance. These acts are easy to miss if you only look for movie-style romance."
              },
              {
                label: "Who It's For",
                text: "Especially for readers who feel their relationship is loving but not \"romantic enough\" — this book validates quiet, stable partnership."
              },
              {
                label: "What Changes",
                text: "You will leave this book seeing reliability not as boring, but as one of the most deeply romantic qualities a partner can possess."
              }
            ].map((item, i) => (
              <div key={i} className="p-6 bg-white rounded-2xl border border-stone-100 shadow-sm">
                <p className="text-xs font-bold uppercase tracking-widest text-brand-500 mb-2">{item.label}</p>
                <p className="text-stone-700 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </motion.div>

        </div>

        {/* Highlighted Positioning Quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-20 text-center"
        >
          <div className="inline-block bg-stone-900 text-white px-10 py-8 rounded-3xl max-w-3xl">
            <p className="text-xl md:text-2xl font-serif italic leading-relaxed">
              "This book reveals the hidden romance in everyday acts of care, loyalty, and presence."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BookSummary;